import React from "react";
import styles from "./Services.module.css";

export default function Services() {
  return <div className="lightSectionContent" id="services">
      <div className="darkSectionTitle">
        <h1>Nasze usługi</h1>
      </div>
      <div className={styles.sectionDescription}>
        <div className={styles.item}>
          <img src={`${process.env.PUBLIC_URL}/Images/wheel2.webp`} alt="wymiana opon" className={styles.imageItem} />
          <p className={styles.descriptionItem}>Wymiana opon</p>
        </div>
        <div className={styles.item}>
          <img src={`${process.env.PUBLIC_URL}/Images/wheel2.webp`} alt="Wyważanie kół" className={styles.imageItem} />
          <p className={styles.descriptionItem}>Wyważanie kół</p>
        </div>
        <div className={styles.item}>
          <img src={`${process.env.PUBLIC_URL}/Images/wheel2.webp`} alt="Naprawa opon" className={styles.imageItem} />
          <p className={styles.descriptionItem}>Naprawa opon</p>
        </div>
        <div className={styles.item}>
          <img src={`${process.env.PUBLIC_URL}/Images/wheel2.webp`} alt="Sezonowe przechowywanie opon" className={styles.imageItem} />
          <p className={styles.descriptionItem}>
            Sezonowe przechowywanie opon
          </p>
        </div>
        <div className={styles.item}>
          <img src={`${process.env.PUBLIC_URL}/Images/wheel2.webp`} alt="Pomiar i uzupełnianie ciśnienia w oponach" className={styles.imageItem} />
          <p className={styles.descriptionItem}>
            Pomiar i uzupełnianie ciśnienia w oponach
          </p>
        </div>
        <div className={styles.item}>
          <img src={`${process.env.PUBLIC_URL}/Images/wheel2.webp`} alt="Czyszczenie i konserwacja felg" className={styles.imageItem} />
          <p className={styles.descriptionItem}>
            Czyszczenie i konserwacja felg
          </p>
        </div>
      </div>
    </div>;
}
